<pbc-sorter [config]="ZeitArtsSorterConfig" [sorter]="zeitArts.sorter$ | async" (sorterChange)="zeitArts.sorter$.next($event)"></pbc-sorter>
